<template>
  <div class="require">
    <h1 class="require_name">发布需求</h1>
    <div class="require_alert">
      <el-alert
        :closable="false"
        title="如果您想快速获得反馈，建议直接扫码添加产品/服务负责人，或拨打服务热线400-831-0631，我们将第一时间为您解答问题。"
        type="primary"
      ></el-alert>
    </div>
    <div class="require_form">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <el-form-item label="联系人" prop="demandName">
          <el-input v-model="form.demandName" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="样品数量" prop="number" id="numberInput">
           <el-input-number style="width: 100%" v-model="form.number" :controls="false" :min="0" :max="1000000" placeholder="请输入样品数量"></el-input-number>
        </el-form-item>
        <el-form-item label="预算范围" prop="rangeOfBudget">
          <el-input v-model="form.rangeOfBudget" placeholder="请输入预算范围"></el-input>
        </el-form-item>
        <el-form-item label="完成周期" prop="accomplishPeriod">
          <el-input v-model="form.accomplishPeriod" placeholder="如一周、十天、一个月、2022-5截止"></el-input>
        </el-form-item>
        <el-form-item label="添加附件" prop="fileList">
            <uploadText
              :fileList="form.fileList"
              ref="getfile"
              style="width: 200px"
              @getFile="getFile"
            ></uploadText>
          </el-form-item>
        <el-form-item label="需求描述" prop="demandDescribe">
          <el-input v-model="form.demandDescribe" type="textarea" :rows="4" maxlength="200" show-word-limit placeholder="必须，请尽量填写仪器名称+检测项目+所用标准+报告用途（200字）"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" style="width: 150px" @click="submitRequire">提交需求</el-button>
    </div>
  </div>
</template>
<script>
import { clientDemand } from "@/api/request"
import uploadText from "../common/uploadText"
import { isMobile, validEmail } from "@/plugins/validate";
export default {
  components: {
    uploadText
  },
  data () {
    var validateMobile = (rule, value, callback) => {
      if (value && !isMobile(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    var validemail = (rule, value, callback) => {
      if (value && !validEmail(value)) {
        return callback(new Error("请输入正确的邮箱"));
      }
      callback();
    };
    return {
      rules: {
        demandName: [
          { required: true, trigger: "blur", message: "请输入联系人" },
          { max: 30, message: "联系人不能超过30个字", trigger: "blur" }
        ],
        phone: [
          { required: true, trigger: "blur", message: "请输入联系电话" },
          { validator: validateMobile, trigger: "blur" }
        ],
        email: [
          { required: true, trigger: "blur", message: "请输入电子邮箱" },
          { validator: validemail, trigger: "blur" }
        ],
        rangeOfBudget: [
          { max: 50, message: "预算范围不能超过50个字", trigger: "blur" }
        ],
        accomplishPeriod: [
          { max: 50, message: "完成周期不能超过50个字", trigger: "blur" }
        ],
        demandDescribe: [
          { required: true, trigger: "blur", message: "请输入需求描述" },
        ]
        
      },
      form: {
        demandName: '',
        phone: '',
        email: '',
        number: undefined,
        rangeOfBudget: '',
        demandDescribe: '',
        fileList: []
      }
    }
  },
  methods: {
    getFile(file) {
      this.form.fileList = file
    },
    submitRequire () {
      this.$refs.getfile.getFile()
      this.$refs.form.validate(valid => {
          if (valid) {
            clientDemand(this.form).then(res=> {
              this.$router.go(-1)
            })
          }
        });
      
    }
  },
  
}
</script>
<style>
.require .el-form-item__content {
  text-align: left;
}
</style>
<style scoped>
.require {
  background: #fff;
  text-align: center;
  width: 60%;
  margin: 20px auto;
  padding-bottom: 50px;
}
.require_name {
  line-height: 100px;
}
.require_alert {
  width: 90%;
  margin: 0 auto;
}
.require_form {
  width: 86%;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #eee;
}
</style>